import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { SettingsService } from '../../settings/settings.service';

@Injectable({providedIn: 'root'})
export class SalesforceAwsProvider extends HttpService {

    /**
     * Serviço de integração ao backend do salesfoce na AWS via API Gateway
     */
    constructor(http: HttpClient, settingsService: SettingsService) {
        super('salesforce-aws', http, settingsService);
    }

}
